import { graphql } from '@client/graphql/types';
import { useQuery } from '@apollo/client';

const QUERY = graphql(`
  query customerCount($companyId: ID!) {
    customerCount(companyId: $companyId)
  }
`);

export default function useCustomerCount(companyId: string) {
  return useQuery(QUERY, {
    variables: { companyId },
  });
}
